import React from 'react';
import SeasonEndDialog from './SeasonEndDialog';
import { usePendingSeasonEnd } from './hooks/usePendingSeasonEnd';
import { useSeasonUiEnabled } from './hooks/useSeasonUiEnabled';

/**
 * @param {{ isLoggedIn: boolean }} props
 */
function SeasonEndDialogHost({ isLoggedIn }) {
  const enabled = useSeasonUiEnabled(!!isLoggedIn);
  const { pendingResult, dialogOpen, dismissDialog } = usePendingSeasonEnd({ enabled });

  return (
    <SeasonEndDialog
      isOpen={dialogOpen}
      result={pendingResult}
      onAcknowledge={dismissDialog}
    />
  );
}

export default SeasonEndDialogHost;
